import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import createRootReducer from './reducers';
import apiMiddleware from '../middleware/apiMiddleware';

export const history = createBrowserHistory();

const  storeconfig = (preloadedState) => {
  const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    createRootReducer(history),
    preloadedState,
    composeEnhancer(applyMiddleware(routerMiddleware(history), apiMiddleware, thunk))
  );

  return store;
}
export default storeconfig;

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('lmsstate');
    if (serializedState === null) return {};
    return JSON.parse(serializedState);
  } catch (err) {
    return {};
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('lmsstate', serializedState);
  } catch (e) {
    // ignore write errors
  }
};
